import type { FreelancerForgotPasswordLocales } from '../types';

const freelancerForgotPasswordLocales: FreelancerForgotPasswordLocales = {
  haveYouForgottenYourPassword:
    'Have you forgotten your password? Enter the email address of your account here to reset your password.',
  resetPassword: 'Reset Password',
  title: 'Forgot Password',
};

export default freelancerForgotPasswordLocales;
